<template>
  <ion-page>
    <ion-content class="ion-padding">
      <ion-spinner v-if="loading" />
      <ion-item v-else-if="error">
        <ion-icon
          slot="start"
          size="large"
          name="alert"
        />
        <ion-label>Connection to our backend services failed.</ion-label>
        <button @click="emergencyLogout" class="btn btn-danger" style="margin-top: 20px;">
          Sitzung zurücksetzen (Logout)
        </button>
      </ion-item>
      <FirebaseLogin v-else-if="!authenticated" />
      <EmailVerification v-else-if="!emailVerified" />
      <NotAuthenticated v-else-if="!authorized" />
      <LoginInfo v-else />
    </ion-content>
  </ion-page>
</template>

<script>
import { mapState } from 'vuex';
import LoginInfo from '@/components/Auth/LoginInfo';
import FirebaseLogin from '@/components/Auth/FirebaseLogin';
import EmailVerification from '@/components/Auth/EmailVerification';
import NotAuthenticated from '@/components/Auth/NotAuthenticated';

export default {
  name: 'Auth',
  components: {
    FirebaseLogin,
    LoginInfo,
    EmailVerification,
    NotAuthenticated,
  },
  computed: {
    ...mapState('auth', ['authenticated', 'emailVerified', 'authorized', 'loading', 'error', 'initialized']),
  },
  methods: {
    emergencyLogout() {
      // Löscht die Firebase-Datenbank und alle Speicher
      indexedDB.deleteDatabase('firebaseLocalStorageDb');
      localStorage.clear();
      sessionStorage.clear();
      // Lädt die Seite hart neu
      window.location.href = '/auth';
    },
  },
};
</script>
